export const Preloader = () => {
  return (
      <div className="flex items-center justify-center">
        <div className="animate-spin rounded-full h-[1.1rem] w-[1.1rem] border-t-4 border-secondary200"></div>
      </div>
  );
};
